import React, { Component } from 'react';
import { connect, Provider } from 'react-redux';
import { Formik, Form } from 'formik';
import FormikCheckbox from '../ui/FormikCheckbox';
import { HousingTypeArray, HostRules } from '../dashboard/listing/constants';
import { FilterAmenities, initialFilters } from './constants';
import { updateFilters, resetFilters } from './actions';
import { CALENDAR_ICON } from '../../constants/images';
import CheckInCheckOutPicker from '../checkInCheckoutPicker/checkInCheckOutPicker';
import GuestsQuantity from '../guestsQuantity/component';
import RoomsQuantity from '../roomsQuantity/component';
import HomeTypeSelect from '../homeTypeSelect/component';
import AmenitiesSelect from '../amenitiesSelect/component';
import HostRulesSelect from '../hostRulesSelect/component';
import DistanceRange from '../distanceRange/component';
import PriceRange from '../priceRange/component';
import { store } from '../../store.js';
import { LOCAL_KEYS } from "../../constants/localStorageKeys";

const mapStateToProps = (state) => ({
  search: state.Search,
});

class SearchFilters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCalendar: false,
      showGuestsField: false,
      homeSelectFocused: false,
      amenitiesFocused: false,
    };
    this.form = React.createRef();

    this.getSelectedHostRules = this.getSelectedHostRules.bind(this);
    this.resetValues = this.resetValues.bind(this);
    this.getInitialFilterValues = this.getInitialFilterValues.bind(this);
    this.buildCheckboxGroupPart = this.buildCheckboxGroupPart.bind(this);
    this.getAppliedHiddenFiltersCount =
      this.getAppliedHiddenFiltersCount.bind(this);
    this.areAnyHiddenFiltersApplied =
      this.areAnyHiddenFiltersApplied.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(updateFilters(this.getInitialFilterValues()));
  }

  buildCheckboxGroupPart = (name, houseType, index) => {
    return (
      <div className="row fieldgroup" key={index}>
        <FormikCheckbox name={name} label={houseType} value={houseType} />
      </div>
    );
  };

  buildCheckboxGroup(name, options) {
    let half = options.length / 2;
    let left = options.slice(0, half);
    let right = options.slice(half);
    return (
      <div className="row">
        <div className="col-lg-6 pr-0 pl-0">
          {left.map((houseType, index) =>
            this.buildCheckboxGroupPart(name, houseType, index)
          )}
        </div>
        <div className="col-lg-6 pr-0 pl-0">
          {right.map((houseType, index) =>
            this.buildCheckboxGroupPart(name, houseType, index)
          )}
        </div>
      </div>
    );
  }

  numberChange = (form, field, num) => {
    let newVal = form.values[field.name] + num;
    newVal = newVal >= 0 ? newVal : 0;
    form.setFieldValue(field.name, newVal);
  };

  searchClicked = (values, { setSubmitting }) => {
    const { filters } = this.props.search;
    this.setState({ showCalendar: false });
    setSubmitting(false);
    this.props.doSearch(filters);
  };

  setDates = (range) => {
    this.form.current.setFieldValue("dates", range);
    if (range.from && range.to) {
      this.setState({ showCalendar: false });
    }
  };
  resetDates = () => {
    this.form.current.setFieldValue("dates", { from: null, to: null });
  };

  toggleCalendar = () => {
    this.setState({ showCalendar: !this.state.showCalendar });
  };

  getSelectedHostRules = () => {
    const { filters } = this.props.search;
    const appliedRules = [];
    if (filters.petsAllowed) appliedRules.push(HostRules.PETS_ALLOWED);
    if (filters.smokingAllowed) appliedRules.push(HostRules.SMOKING_ALLOWED);

    return appliedRules;
  };

  resetValues = () => {
    const { dispatch } = this.props;
    dispatch(resetFilters());
  };

  getInitialFilterValues = () => {
    const { filters } = this.props.search;
    const initialFilterValues = localStorage.getItem(LOCAL_KEYS.FILTER_VALUES);
    return initialFilterValues ? JSON.parse(initialFilterValues) : filters;
  };

  getAppliedHiddenFiltersCount = () => {
    const { filters } = this.props.search;
    let appliedFiltersCount = 0;

    if (
      filters.price.min !== initialFilters.price.min ||
      filters.price.max !== initialFilters.price.max
    )
      ++appliedFiltersCount;

    if (
      filters.petsAllowed !== initialFilters.petsAllowed ||
      filters.smokingAllowed !== initialFilters.smokingAllowed
    )
      ++appliedFiltersCount;

    if (filters.radius !== initialFilters.radius) ++appliedFiltersCount;

    return appliedFiltersCount;
  };

  areAnyHiddenFiltersApplied = () => {
    return this.getAppliedHiddenFiltersCount() > 0;
  };

  render() {
    let filterValues = this.props.search.filters;

    if (!filterValues.radius) filterValues.radius = "30";

    const hiddenFiltersCount = this.areAnyHiddenFiltersApplied()
      ? `(${this.getAppliedHiddenFiltersCount()})`
      : "";

    return (
      <Formik
        onSubmit={this.searchClicked}
        initialValues={this.getInitialFilterValues()}
        ref={this.form}
      >
        {({ values }) => (
          <Form>
            <div className="filters-container search-filter-container">
              <div className="row basic-filters">
                <div className="d-flex filter-row">
                  <div className="date-picker-wrapper mb-3">
                    <Provider store={store}>
                      <CheckInCheckOutPicker />
                    </Provider>
                    <img
                      src={CALENDAR_ICON}
                      alt="calendar"
                      className="icon-image"
                    />
                  </div>
                  <div className="guest-input mb-3">
                    <Provider store={store}>
                      <GuestsQuantity showMessageOnNone showLabel />
                    </Provider>
                  </div>
                  <div className="guest-input mb-3">
                    <Provider store={store}>
                      <RoomsQuantity />
                    </Provider>
                  </div>
                  <div
                    className="dropdown-input-box mb-3"
                    style={{ zIndex: this.state.homeSelectFocused ? 100 : 1 }}
                  >
                    <Provider store={store}>
                      <HomeTypeSelect
                        homeTypes={HousingTypeArray.sort()}
                        selectedValues={filterValues.typeOfHome}
                        onFocus={() => {
                          this.setState({
                            ...this.state,
                            homeSelectFocused: true,
                            amenitiesFocused: false,
                          });
                        }}
                      />
                    </Provider>
                  </div>
                  <div
                    className="dropdown-input-box mb-3"
                    style={{ zIndex: this.state.amenitiesFocused ? 100 : 1 }}
                  >
                    <Provider store={store}>
                      <AmenitiesSelect
                        amenities={FilterAmenities}
                        selectedValues={filterValues.amenities}
                        onFocus={() => {
                          this.setState({
                            ...this.state,
                            homeSelectFocused: false,
                            amenitiesFocused: true,
                          });
                        }}
                      />
                    </Provider>
                  </div>
                </div>
              </div>
              <div className="advanced-filters">
                <div className="first-column">
                  <div className="header-row">Host Rules</div>
                  <Provider store={store}>
                    <HostRulesSelect
                      rules={Object.values(HostRules)}
                      appliedRules={this.getSelectedHostRules()}
                    />
                  </Provider>
                </div>
                <div className="second-column">
                  <div className="header-row">Distance from Location</div>
                  <Provider store={store}>
                    <DistanceRange />
                  </Provider>
                </div>
                <div className="third-column">
                  <div className="header-row">Price Range</div>
                  <Provider store={store}>
                    <PriceRange />
                  </Provider>
                </div>
                <div className="submit-button">
                  <button type="submit" className="float-right ml-2">
                    Apply
                  </button>
                  <button
                    type="button"
                    className="float-right white"
                    onClick={this.resetValues}
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

export default connect(mapStateToProps)(SearchFilters);
